import type { CalendarSlotColor } from '@unipostudio/platform-constants';
import { api } from './api';

/** The TanStack Query key of every slots list (the calendar, and the AI schedule card that adds slots). */
export const CALENDAR_SLOTS_KEY = 'calendar-slots';

/** A campaign slot on the calendar (Task 5.2): a planned post before the content exists. */
export interface CalendarSlot {
  id: string;
  /** YYYY-MM-DD. */
  date: string;
  /** HH:mm, or null for some time that day. */
  time: string | null;
  label: string;
  platforms: string[];
  notes: string | null;
  colorKey: CalendarSlotColor;
  campaign: string | null;
  /** The post saved from it; null while it is empty (or its post was deleted). */
  postId: string | null;
  createdBy: string;
  createdAt: string;
}

export interface CalendarSlotInput {
  date: string;
  time?: string | null;
  label: string;
  platforms?: string[];
  notes?: string | null;
  colorKey?: CalendarSlotColor;
  campaign?: string | null;
}

/** /api/v1/calendar/slots (docs/features/calendar-slots.md). */
export const calendarSlotsService = {
  async list(from: string, to: string): Promise<CalendarSlot[]> {
    return (await api.get<CalendarSlot[]>('/calendar/slots', { params: { from, to } })).data;
  },
  async create(input: CalendarSlotInput): Promise<CalendarSlot> {
    return (await api.post<CalendarSlot>('/calendar/slots', input)).data;
  },
  async update(id: string, patch: Partial<CalendarSlotInput>): Promise<CalendarSlot> {
    return (await api.patch<CalendarSlot>(`/calendar/slots/${id}`, patch)).data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/calendar/slots/${id}`);
  },
  async fill(id: string, postId: string): Promise<CalendarSlot> {
    return (await api.post<CalendarSlot>(`/calendar/slots/${id}/fill`, { postId })).data;
  },
};
